import ShareNotFoundIcon from '../../media/no-data.png'

export default function ShareNotFound() {
  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <img style={styles.img} src={ShareNotFoundIcon} alt='' />
        <h2 style={styles.h2}>Share Not Found</h2>
        <p style={styles.p}>The shared item could not be found.</p>
        <p style={styles.sub_p}>It may have been deleted or the link is invalid.</p>
      </div>
    </div>
  );
}

const styles = {
  img:{
    width:310
  },
  h2:{
    fontWeight: 500,
    fontSize: 20,
    marginTop:10,
    marginBottom:5

  },
  p:{
    marginTop:0,
    color: "#C8CDD0",
    fontSize:16,
    marginBottom:5
  },
  sub_p:{
    marginTop:0,
    color: "#C8CDD0",
    fontSize:16

  },
  wrapper: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#fff",
  },
  card: {
    textAlign: "center",
  },
};